import type { BrandConfig } from './types';

/** Comportamento histórico Meu Sacramento (default seguro). */
export const platformBrand: BrandConfig = {
  key: 'platform',
  displayName: 'Meu Sacramento',
  logoUrl: `${process.env.PUBLIC_URL || ''}/meusacramento01.svg`,
  favicons: [{ rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }],
  documentTitle: 'Eventos Católicos',
  og: {
    title: 'Eventos Católicos - Meu Sacramento',
    description: 'Crie, divulgue e gerencie eventos católicos com inscrições online.',
    image: '/og-banner.png',
    url: 'https://meusacramento.store',
    siteName: 'Eventos Católicos',
  },
  landingTemplate: 'events_bio',
  publicPage: {
    flatPage: false,
    pageBg: '#f2f5fb',
    pageBgDeep: '#e8eef8',
    text: '#241a37',
    textSoft: '#4f5870',
    heading: '#4b1b7a',
    accent: '#4b1b7a',
    accentSoft: '#eee8fb',
    border: '#d6deed',
    surface: '#f4f7ff',
    surfaceSoft: '#fbfcff',
    cardShadow: '0 18px 38px rgba(22, 34, 68, 0.14)',
    ctaStart: '#4b1b7a',
    ctaEnd: '#6f42a8',
    ctaShadow: 'rgba(75, 27, 122, 0.30)',
  },
  copy: {
    auth: {
      loginTitle: 'Entrar na Plataforma',
      loginSubtitle: 'Acesse seu painel administrativo com seguranca.',
      footerShort: `© ${new Date().getFullYear()} Meu Sacramento`,
      footerWide: `© ${new Date().getFullYear()} Meu Sacramento. Todos os direitos reservados.`,
      forgotPasswordHint:
        'da plataforma (não o e-mail institucional da paróquia, se for diferente).',
    },
    chrome: {
      sidebarTitle: 'Meu Sacramento',
      sidebarSubtitle: 'Painel operacional',
      footerCopyright: `© ${new Date().getFullYear()} Meu Sacramento - Conectando comunidades através da fé`,
      showAcutisQuote: true,
      showSupportEmail: true,
      supportEmail: 'suporte@meusacramento.com',
      supportInstagram: 'meusacramento',
    },
    eventForm: {
      titlePlaceholder: 'Ex: Retiro de Jovens 2025',
      slugPlaceholder: 'ex: retiro-jovens-2025',
      slugHelper:
        'Esse identificador será usado na URL do evento. Ex: /paroquia-slug/retiro-jovens-2025',
      locationPlaceholder: 'Ex: Paróquia Nossa Senhora Aparecida',
      descriptionPlaceholder:
        'Descreva seu evento com detalhes: objetivo, programação, público-alvo...',
      contactEmailPlaceholder: 'Ex: evento@paroquia.com.br',
      promoLinkPlaceholder: 'Ex.: WhatsApp do grupo RCC, Instagram da paróquia',
      categories: [
        { value: 'missa', label: 'Missa' },
        { value: 'retiro', label: 'Retiro' },
        { value: 'formacao', label: 'Formação' },
        { value: 'adoracao', label: 'Adoração' },
        { value: 'confissao', label: 'Confissão' },
        { value: 'festa', label: 'Festa Religiosa' },
        { value: 'encontro', label: 'Encontro' },
        { value: 'grupo_oracao', label: 'Grupo de Oração' },
        { value: 'catequese', label: 'Catequese' },
        { value: 'peregrinacao', label: 'Peregrinação' },
        { value: 'other', label: 'Outro' },
        { value: 'none', label: 'Sem categoria' },
      ],
      steps: [
        { label: 'Informações Básicas', description: 'Detalhes essenciais do evento' },
        { label: 'Ingressos e Pagamentos', description: 'Configure opções de pagamento' },
        { label: 'Inscrições', description: 'Defina o processo de inscrição' },
        { label: 'Página do Evento', description: 'Personalize a aparência' },
      ],
      registrationSettingsTitle: 'Configurações de Inscrição',
      registrationSettingsHelp: 'Configure como os participantes se inscreverão no seu evento',
      registrationDeadlineLabel: 'Prazo de Inscrição',
    },
    home: {
      chip: 'MOSAICO DE EXPERIENCIAS',
      title: 'Seu proximo evento',
      titleAccent: 'esta aqui',
      subtitle: 'Missas, encontros e tudo que acontece na Igreja - organizado em um so lugar.',
      ctaExplore: 'Explorar Agora',
      ctaSecondary: 'Saiba Mais',
      ctaSecondaryHref: '/cadastro-paroquia',
      eventsChip: 'EVENTOS EM DESTAQUE',
      eventsTitle: 'Próximos Eventos',
      eventsSubtitle: 'Descubra os eventos mais esperados das paróquias da sua região',
      eventsCountLabel: 'Eventos',
      emptyTitle: 'Nenhum evento encontrado',
      emptySubtitle: 'Novos eventos serão exibidos aqui em breve.',
      fallbackCover: 'https://source.unsplash.com/random/800x400/?church',
    },
  },
};
